import { isLogin } from '@/composables/user/users'
import { isIOS } from '@/utils/device'
import { inMiniprograme } from '@/utils/util'

const ONE_DAY_MS = 24 * 60 * 60 * 1000
//const ONE_DAY_MS = 15 * 1000
const RELOGIN_LOCK_MS =  60 * 60 * 1000
const MINIAPP_RELOGIN_TIME_KEY = 'miniappReloginTimeV2'
const MINIAPP_RELOGIN_LOCK_KEY = 'miniappReloginLockV2'

export default defineNuxtPlugin(() => {
  const router = useRouter()
  const miniappReloginTime = useLocalStorage<string>(MINIAPP_RELOGIN_TIME_KEY, '')
  const miniappReloginLock = useLocalStorage<string>(MINIAPP_RELOGIN_LOCK_KEY, '')

  async function checkMiniappRelogin(toFullPath: string) {
    if (!shouldCheckRelogin(toFullPath)) {
      return
    }

    const now = Date.now()
    const lastReloginTime = Number(miniappReloginTime.value || 0)
    const lockTime = Number(miniappReloginLock.value || 0)


    if (lockTime > 0 && now - lockTime <= RELOGIN_LOCK_MS) {
      return
    }
    if (lockTime > 0) {
      miniappReloginLock.value = ''
    }

    if (now - lastReloginTime <= ONE_DAY_MS) {
      return
    }

    const returnUrl = buildReturnUrl(window.location.href)
    if (!returnUrl) {
      return
    }
    miniappReloginLock.value = String(now)
    try {
      const origin = window.location.origin
      const subappUrl = `${origin}/subappLogin?login=miniapp&returnUrl=${encodeURIComponent(returnUrl)}`
      const module = await import('weixin-js-sdk')
      const wx = (module as any).default || module


      if (!wx?.miniProgram?.redirectTo) {
        throw new Error('miniProgram.redirectTo is unavailable')
      }
      wx.miniProgram.redirectTo({
        url: `/pages/webview/webview?url=${encodeURIComponent(subappUrl)}`
      })
    } catch (error) {
      console.error('[miniapp-relogin] redirect failed', error)
      miniappReloginLock.value = ''
    }
  }

  router.afterEach((to) => {
    void checkMiniappRelogin(to.fullPath)
  })
  void checkMiniappRelogin(router.currentRoute.value.fullPath)

  function shouldCheckRelogin(toFullPath: string) {
    if (import.meta.server) {
      return false
    }

    if (!isLogin.value || !isIOS() || !inMiniprograme.value) {
      return false
    }

    if (toFullPath.startsWith('/subappLogin')) {
      return false
    }

    const currentUrl = new URL(window.location.href)
    if (currentUrl.searchParams.has('minicode') || currentUrl.searchParams.get('login') === 'miniapp') {
      return false
    }

    return true
  }

  function buildReturnUrl(rawUrl: string) {
    try {
      const currentUrl = new URL(rawUrl)
      currentUrl.searchParams.delete('minicode')
      currentUrl.searchParams.delete('code')
      currentUrl.searchParams.delete('login')
      const sanitizedUrl = `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`
      return sanitizedUrl
    } catch (error) {
      console.error('[miniapp-relogin] invalid return url', error)
      return ''
    }
  }
})
